module.exports = __webpack_public_path__ + "static/e-cohabiter_logo_white-aec7cb93f93816f6ee2123004c5c3106.svg";